import React, { useEffect, useInsertionEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";

import { Ismobiles, getBase64, getMemberinfo, hpHypen, numFormat } from "../utils/utils";
import { close, loadingflas, open } from '../redux/popupSlice';

import * as APIS from "../utils/service";
import consts from '../libs/consts';
import userEvent from '@testing-library/user-event';


export default function Profiles(props) {

    const { 
        profileimgs=false,
        margintClass='',
        mypages=false,
        memberinfosData=null,
        companyinfos=null,
        Trophyinfo=true,
        profilesimgButtons=true,
        favremove=false,
        blackremove=false,
        favblackData={}
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [memberinfos, setmemberinfos] = useState(''); 
    const [favblackDatas, setfavblackDatas] = useState(favblackData); 
    const selectFile = useRef(null);

    const [bedge, setbedge] = useState(''); 
    const [bedgetropy, setbedgetropy] = useState(''); 
    
    // useEffect(() => {
    //     //getMemberinfo(setmemberinfos);
    // }, []);
    useEffect(() => {
        if(memberinfosData !== null){
            setmemberinfos(memberinfosData);
        }
    }, [memberinfosData]);


    useEffect(() => {
        if(memberinfos){
            let bedge = memberinfos?.badges?.filter(item => item.type !== 1);
            setbedge(bedge);
            console.log(memberinfos?.badges?.filter(item => item.type === 1));
            setbedgetropy(memberinfos?.badges?.filter(item => item.type === 1)[0]);
        }
    }, [memberinfos]);
    
    return (
        <>
        {memberinfos &&
            <div className={`storedamdang ${margintClass}`} style={{ position: 'relative', }}>
                {favremove === true &&
                    <button
                        style={{
                            position: 'absolute', right: -15, top: -15, padding: 10, 
                        }}
                        onClick={() => {
                            if(memberinfos?.favflas){
                                //remove
                                //add
                                let sender = {
                                    idx: favblackDatas?.idx,
                                }
                                dispatch(loadingflas({ loading: true }));
                                APIS.postData('/v1/auth/favRemove', sender).then(({ data }) => {
                                    if(data > 0){
                                        setmemberinfos({ ...memberinfos, favflas: false});
                                    }
                                }).catch(({ response }) => {
                                    const { data } = response;
                                }).finally(() => {
                                    dispatch(loadingflas({ loading: false }));
                                });  

                            } else {
                                //add
                                let sender = {
                                    target_idx: memberinfos?.idx,
                                }
                                dispatch(loadingflas({ loading: true }));
                                APIS.postData('/v1/auth/favInsert', sender).then(({ data }) => {
                                    if(data > 0){
                                        setmemberinfos({ ...memberinfos, favflas: true});
                                        setfavblackDatas({ ...favblackDatas, idx: data});
                                        
                                    }
                                }).catch(({ response }) => {
                                    const { data } = response;
                                    console.log(data);
                                }).finally(() => {
                                    dispatch(loadingflas({ loading: false }));
                                });  
                                
                            }
                        }}
                    >
                        {memberinfos?.favflas === true ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M10.0003 15.2165L4.12246 18.5067L5.43524 11.8998L0.489746 7.32634L7.17895 6.53322L10.0003 0.416504L12.8217 6.53322L19.5108 7.32634L14.5654 11.8998L15.8782 18.5067L10.0003 15.2165Z" fill="#FF0000"/>
                        </svg>
                        :
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M10.0003 15.2165L4.12246 18.5067L5.43524 11.8998L0.489746 7.32634L7.17895 6.53322L10.0003 0.416504L12.8217 6.53322L19.5108 7.32634L14.5654 11.8998L15.8782 18.5067L10.0003 15.2165ZM10.0003 13.3065L13.5393 15.2874L12.7488 11.3096L15.7264 8.556L11.699 8.07845L10.0003 4.39569L8.30162 8.07845L4.27418 8.556L7.25176 11.3096L6.46136 15.2874L10.0003 13.3065Z" fill="#CCCCCC"/>
                        </svg>                        
                        }
                    </button>
                }

                {blackremove === true &&
                    <button
                        style={{
                            position: 'absolute', right: -15, top: -15, padding: 10, 
                        }}
                        onClick={() => {
                            if(memberinfos?.blackflas){
                                //remove
                                //add
                                let sender = {
                                    idx: favblackDatas?.idx,
                                }
                                dispatch(loadingflas({ loading: true }));
                                APIS.postData('/v1/auth/blackRemove', sender).then(({ data }) => {
                                    if(data > 0){
                                        setmemberinfos({ ...memberinfos, blackflas: false});
                                    }
                                }).catch(({ response }) => {
                                    const { data } = response;
                                    console.log(data);
                                }).finally(() => {
                                    dispatch(loadingflas({ loading: false }));
                                });  

                            } else {
                                //add
                                let sender = {
                                    target_idx: memberinfos?.idx,
                                }
                                dispatch(loadingflas({ loading: true }));
                                APIS.postData('/v1/auth/blackInsert', sender).then(({ data }) => {
                                    if(data > 0){
                                        console.log(data);
                                        setmemberinfos({ ...memberinfos, blackflas: true});
                                        setfavblackDatas({ ...favblackDatas, idx: data});
                                    }
                                }).catch(({ response }) => {
                                    const { data } = response;
                                    console.log(data);
                                }).finally(() => {
                                    dispatch(loadingflas({ loading: false }));
                                });  
                                
                            }
                        }}
                    >
                        {memberinfos?.blackflas === true ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z" fill="#999999"/>
                        </svg>
                        :
                        <span>추가</span>                      
                        }
                    </button>
                }


                {profileimgs === true && 
                    <>
                    <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                        let file = e.target.files[0];
                        getBase64(file).then(result => {
                            file["base64"] = result;
                            file["ext"] = file.name.split('.')[1];
                            let sender = {
                                files: {
                                    base: result,
                                    ext: file.name.split('.')[1]
                                },
                            }
                            console.log(sender);
                            dispatch(loadingflas({ loading: true }));
                            APIS.postData('/v1/auth/profile', sender).then(({ data }) => {
                                console.log(data);
                                if(data){
                                    getMemberinfo(setmemberinfos);
                                }
                            }).catch(({ response }) => {
                                const { data } = response;
                                console.log(data);
                            }).finally(() => {
                                dispatch(loadingflas({ loading: false }));
                            });  
                        })
                        .catch(err => { console.log(err); });
                    }} />                     
                    <div className='profileImages'>
                        <div
                            style={{
                                backgroundImage: `${memberinfos?.profile ? "url('"+ consts.s3url +"/"+ memberinfos?.profile +"')" : "url('./images/icons/user-3-fill.svg')"}`,
                                backgroundSize: `${memberinfos?.profile ? "cover" : ""}`
                            }}                        
                        >
                            {profilesimgButtons === true &&
                            <>
                                <button 
                                    type='button'
                                    onClick={() => {
                                        selectFile.current.click();
                                    }}
                                    style={{
                                        backgroundColor: '#333', width: 32, height: 32,
                                        borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                    }}
                                >
                                    <img src="./images/icons/camera.svg" />      
                                </button>       
                                {memberinfos?.profile &&
                                <button 
                                    type='button'
                                    onClick={() => {

                                        dispatch(
                                            open({
                                                component: '삭제하시겠습니까?',
                                                title: '알림',
                                                button: "확인",
                                                buttonCencle: "취소",       
                                                titleviewer: true,                 
                                                alert: false,
                                                onPress: () => {
                                                    let sender = {}
                                                    console.log(sender);
                                                    dispatch(loadingflas({ loading: true }));
                                                    APIS.postData('/v1/auth/profileRemove', sender).then(({ data }) => {
                                                        if(data){
                                                            getMemberinfo(setmemberinfos);
                                                            dispatch(close());
                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    });    
                                                    
                                                },
                                                onCancelPress: () => {
                                                    dispatch(close());
                                                }
                                            })
                                        );  
                                    }}
                                    style={{
                                        backgroundColor: '#ddd', width: 32, height: 32, position: 'absolute', left: -15, bottom: 0,
                                        borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M14.1667 4.99999H18.3333V6.66666H16.6667V17.5C16.6667 17.9602 16.2936 18.3333 15.8333 18.3333H4.16667C3.70644 18.3333 3.33334 17.9602 3.33334 17.5V6.66666H1.66667V4.99999H5.83334V2.49999C5.83334 2.03976 6.20644 1.66666 6.66667 1.66666H13.3333C13.7936 1.66666 14.1667 2.03976 14.1667 2.49999V4.99999ZM15 6.66666H5.00001V16.6667H15V6.66666ZM7.5 9.16666H9.16667V14.1667H7.5V9.16666ZM10.8333 9.16666H12.5V14.1667H10.8333V9.16666ZM7.5 3.33332V4.99999H12.5V3.33332H7.5Z" fill="#fff"/>
                                    </svg>  
                                </button>  
                                } 
                            </>
                            }                    
                        </div>
                    </div>
                    </>
                }
                <div className='Trophyarea'>
                    {bedgetropy &&
                    <img src={`${consts?.s3url}/${bedgetropy?.file_path}`} style={{ width: 20}}  />
                    }                            
                    <span>{memberinfos?.name} {memberinfos?.rank}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {memberinfos?.level*1 === 1 && '중개보조원'}
                    {memberinfos?.level*1 === 2 && '공인중개사'}
                    {memberinfos?.level*1 === 3 && '대표공인중개사'}
                </div>
                <div className='Trophystickarea'>
                    {bedge?.length > 0 && bedge?.map((x, i) => {
                        return (
                            <>
                            <div key={`bedge${i}`} className="trophysticker style3">{x?.title}</div>
                            </>
                        );
                    })}
                </div>

                <div className='Trophyphone'>{hpHypen(memberinfos?.hp)}</div>
                {memberinfos?.compony &&
                    <>
                    <div className='Trophyaddr'>{memberinfos?.compony?.title}({memberinfos?.compony?.addr})</div>
                    <div className='Trophyaddr'>대표번호 : {memberinfos?.compony?.company_phone}</div>
                    </>
                }
                                                
                {/* {mypages === false &&
                <>
                <div className='Trophyphone'>{hpHypen(memberinfos?.hp)}</div>
                {memberinfos?.compony &&
                    <div className='Trophyaddr'>{memberinfos?.compony?.title}({memberinfos?.compony?.addr})</div>
                }
                </>
                } */}
                {Trophyinfo === true &&
                <div className='Trophycountinfo'>
                    <div>
                        <div>전체<br />공동중개</div>
                        <div>{memberinfos?.mediation_count*1 > 4 ? numFormat(memberinfos?.mediation_count) : '-'}건</div>
                    </div>
                    <div>
                        <div>최근 3개월간<br />공동중개</div>
                        <div className='lightblue'>{memberinfos?.mediation_count*1 > 4 ? numFormat(memberinfos?.mediation_count_3m) : '-'}건</div>
                    </div>
                    <div>
                        <div>평가점수<br />(상위)</div>
                        <div className='lightblue'>{memberinfos?.mediation_count*1 > 4 ? memberinfos?.score_per !== null ? memberinfos?.score_per : '-' : '-' }%</div>
                    </div>
                </div>
                }
            </div>
        }
        </>
    )    
}